import { Link } from "react-router-dom";
import { friendlyLinks } from "@/mocks/specials";

const quickLinks = [
  { name: "首页", path: "/" },
  { name: "赛事分类", path: "/category" },
  { name: "赛事专题", path: "/special" },
  { name: "关于我们", path: "/about" },
];

const typeLinks = ["电子竞技", "体育竞技", "棋牌竞技", "极限运动"];

export default function SiteFooter() {
  return (
    <footer className="mt-20 w-full bg-secondary-950 text-secondary-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 font-heading text-lg font-extrabold text-foreground-950">
                51
              </span>
              <span className="flex flex-col leading-tight">
                <span className="font-heading text-lg font-extrabold text-background-50">
                  51每日大赛今日黑聚集地详情
                </span>
                <span className="text-xs text-secondary-300">权威赛事资讯与详细介绍平台</span>
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-secondary-300">
              面向电竞与体育赛事爱好者的专业资讯平台，提供最新每日大赛信息、详细赛事介绍与动态更新，帮助用户快速获取权威赛况与深度分析。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              {["ri-weibo-line", "ri-wechat-line", "ri-qq-line", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md bg-secondary-900 text-secondary-200 transition-colors hover:bg-accent-500 hover:text-foreground-950"
                >
                  <i className={`${icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">站内导航</h4>
            <ul className="mt-4 space-y-3 text-sm">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-secondary-300 transition-colors hover:text-accent-400"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/category"
                  className="text-secondary-300 transition-colors hover:text-accent-400"
                >
                  友情链接
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">赛事类型</h4>
            <ul className="mt-4 space-y-3 text-sm">
              {typeLinks.map((type) => (
                <li key={type}>
                  <Link
                    to={`/category?category=${encodeURIComponent(type)}`}
                    className="text-secondary-300 transition-colors hover:text-accent-400"
                  >
                    {type}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-secondary-800 pt-8">
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-xs text-secondary-400">
            <span className="font-medium text-secondary-300">友情链接：</span>
            {friendlyLinks.map((link) => (
              <Link
                key={link.name}
                to={link.url}
                className="transition-colors hover:text-accent-400"
              >
                {link.name}
              </Link>
            ))}
          </div>
          <div className="mt-6 flex flex-col gap-5 border-t border-secondary-800 pt-6 sm:flex-row sm:items-start sm:justify-between">
            <div className="flex flex-col gap-2 text-xs text-secondary-400">
              <p>联系邮箱：contact@51daily-arena.example</p>
              <p>合作咨询：+86 021-8888-5151（工作日 9:00 - 18:00）</p>
            </div>
            <div className="max-w-lg text-xs leading-relaxed text-secondary-500">
              <p>免责声明：本站所有赛事名称、时间、队伍及数据均为演示用虚构内容，不对应任何真实赛事或机构。站内搜索、筛选与排序功能均为前端模拟展示。</p>
              <p className="mt-2">© 2026 51每日大赛今日黑聚集地详情 版权所有</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}